import React from 'react';
import { useDialogs } from '../hooks';
import { useFunctions } from '../hooks';

// Custom imports:
import { Modal, Text, Input, Button } from '../components';
import { useTranslation } from 'react-i18next';

const Document_nameDialog = () => {
    const { run } = useFunctions();
    // Custom exports:
	const { t } = useTranslation();

    // Custom functions:
	const document_name_buttons_positiveOnClick = (options) => {
		run([{"id":"do1683490801667","function":"do","if":{"what":"@property.premium","is":true},"what":[{"id":"add1683490828465","function":"add","what":{"user_id":"@firebase.user.id","created_at":"@cookie.timestamp","name":"@property.name","doc_content":"@cookie.generation.doc_content","type":"@cookie.generation.type","part_1":"@cookie.generation.part_1","part_2":"@cookie.generation.part_2","part_3":"@cookie.generation.part_3","language":"@cookie.generation.language","country":"@cookie.generation.country","description":"@cookie.generation.description","antecedents":"@database.contract.antecedents","intentions":"@cookie.generation.intentions"},"to":"@firebase.firestore.documents"},{"id":"goto1683490828465","function":"goto","view":"dashboard"}]},{"id":"do1683490821250","function":"do","if":{"what":"@property.premium","is_not":true},"what":[{"id":"set1683491022249","function":"set","what":"@property.firstDocument","value":true,"if":{"what":"@firebase.firestore.documents.(@firebase.user.id).created_at","is":null,"else":[{"id":"set1683491060420","function":"set","what":"@property.firstDocument","value":false}]}},{"id":"do1683490948489","function":"do","if":{"what":"@property.firstDocument","is":true},"what":[{"id":"add1683490990114","function":"add","what":{"user_id":"@firebase.user.id","created_at":"@cookie.timestamp","name":"@property.name","doc_content":"@cookie.generation.doc_content","type":"@cookie.generation.type","part_1":"@cookie.generation.part_1","part_2":"@cookie.generation.part_2","part_3":"@cookie.generation.part_3","language":"@cookie.generation.language","country":"@cookie.generation.country","description":"@cookie.generation.description","information":"@cookie.generation.information"},"to":"@firebase.firestore.documents","key":"@firebase.user.id"},{"id":"goto1683490990114","function":"goto","view":"dashboard"}],"comments":"No other document stored"},{"id":"do1683491921895","function":"do","if":{"what":"@property.firstDocument","is_not":true},"what":[{"id":"popup1683491952675","function":"popup","dialog":"storage_limit"}],"comments":"Storage limit"}]},{"function":"hide","dialog":"document_name"}], options)
	}
	const document_name_buttons_negativeOnClick = (options) => {
		run([{"function":"hide","dialog":"document_name"}], options)
	}

  return (
    
    
			<Modal id="document_name" centered>
					<Modal.Body>
						<Text
							id="text1683105191343"
							className="w-100 h-auto position-relative" >
							{t('document_name.text1683105191343')}
						</Text>
						<Input.Text
							id="inputtext1683105289371"
							name="text"
							src="@property.name"
							className="w-100 h-auto position-relative mt-24px" />
					</Modal.Body>
					<Modal.Footer>
						<Button
							id="document_name_buttons_negative"
							onClick={document_name_buttons_negativeOnClick}
							variant="transparent"
							className="w-auto h-auto position-relative" >
							{t('document_name.document_name_buttons_negative')}
						</Button>
						<Button
							id="document_name_buttons_positive"
							onClick={document_name_buttons_positiveOnClick}
							variant="primary"
							className="w-auto h-auto position-relative" >
							{t('document_name.document_name_buttons_positive')}
						</Button>
					</Modal.Footer>
			</Modal>
    
  );
};

export default Document_nameDialog;
